<template>
  <blockquote v-if="debug">
    prop: <code>{{ modelValue }}</code><i v-if="modelValue === null">null</i><i v-if="modelValue === undefined">undefined</i><br />
    item:
    <JsonViewer :data="item" />
  </blockquote>
  <ion-item>
    <ion-label slot="start">Container</ion-label>
    <ApiIcon
      v-if="item?.object?.logo"
      :type="item.object.logo.type"
      :name="item.object.logo.name"
      :iconStyle="item.object.logo.style"
    />
    <ApiIcon
      v-else
      :type="'fa'"
      :name="'box'"
      :iconStyle="'solid'"
    />
    <ion-label v-if="item?.object?.name">{{ item.object.name }}</ion-label>
    <ion-button @click="chooseContainerModalIsOpen = true" slot="end">Change</ion-button>
  </ion-item>
  <ion-modal
    :is-open="chooseContainerModalIsOpen"
    :can-dismiss="true"
    :backdrop-dismiss="true"
    @didDismiss="chooseContainerModalIsOpen = false"
  >
    <ChooseContainerModal
      v-model="item"
      @close="chooseContainerModalIsOpen = false"
      @save="chooseContainerModalIsOpen = false"
    />
  </ion-modal>
</template>
<script setup lang="ts">
import ApiIcon from "@/components/ApiIcon.vue";
import { IonItem, IonLabel, IonButton, IonModal } from "@ionic/vue";
import ChooseContainerModal from "@/components/modals/ChooseContainerModal.vue";
// noinspection ES6UnusedImports
import { defineComponent, ref, watch } from "vue";
// noinspection ES6UnusedImports
import type { ApiObjectWithReferences } from "@/models/api";
import { undefinedToNull } from "@/helper/undefinedToNull";
import JsonViewer from "@/components/JsonViewer.vue";
import { useApiStore } from "@/stores/api";

const api = useApiStore();

defineComponent({
  name: "ChooseIconInput",
});

const props = defineProps<{
  // either the object, or it's id.
  modelValue:
    | ApiObjectWithReferences
    | ApiObjectWithReferences["object"]["id"]
    | null;
}>();

const emit = defineEmits<{
  (
    e: "update:modelValue",
    value: ApiObjectWithReferences["object"]["id"] | null
  ): void;
}>();

const debug = ref(false);
const chooseContainerModalIsOpen = ref(false);
const item = ref<ApiObjectWithReferences | null>(
  typeof props.modelValue == "number"
    ? api.byId(props.modelValue)?.data ?? null
    : undefinedToNull(props.modelValue)
);
watch(
  () => props.modelValue,
  (newValue) => {
    item.value = typeof newValue == "number"
      ? api.byId(newValue)?.data ?? null
      : undefinedToNull(newValue);
  }
);
watch(item, (newVal, oldVal) => {
  console.log("choosenIcon:", newVal);
  if (newVal !== oldVal) {
    emit("update:modelValue", newVal?.object.id ?? null);
  }
});
</script>
<style scoped></style>
